import { Components, Theme } from '@mui/material';

const makeMuiCard = (theme: Theme): Components['MuiCard'] => ({
  styleOverrides: { root: { borderRadius: theme.shape.borderRadius } },
});

export default makeMuiCard;
